
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soru-cozum/[questionSlug]",
      function () {
        return require("private-next-pages/soru-cozum/[questionSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soru-cozum/[questionSlug]"])
      });
    }
  